import { useTour } from './TourContext';
import { tourConfig } from './tourConfig';

export const useTourTarget = (id: string) => {
  const { activeTour, currentStep, nextStep, completeTour } = useTour();
  const tour = activeTour ? tourConfig[activeTour] : null;
  const isLastStep = tour ? currentStep === tour.steps.length - 1 : false;

  const handleClick = () => {
    if (!activeTour || !tour) return;

    const currentTourStep = tour.steps[currentStep];
    if (currentTourStep?.target === `#${id}`) {
      if (isLastStep) {
        completeTour();
      } else {
        nextStep();
      }
    }
  };

  return { onClick: handleClick };
};
